import moment from "moment";

const DIAS_LARGOS = [
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
  "Domingo",
];
const DIAS_CORTOS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

export const getSemana = (offsetSemanas = 0) => {
  const lunesActual = moment().startOf("isoWeek");
  const lunes = lunesActual.clone().add(offsetSemanas * 7, "days");

  const dias = [];
  for (let i = 0; i <= 4; i++) {
    const dia = lunes.clone().add(i, "days");
    dias.push({
      fecha: dia.format("YYYY-MM-DD"),
      label: DIAS_LARGOS[i],
      labelCorto: DIAS_CORTOS[i],
      diaMes: dia.format("DD/MM"),
      esHoy: dia.isSame(moment(), "day"),
      esPasado: dia.isBefore(moment(), "day"),
    });
  }

  return {
    desde: lunes.format("YYYY-MM-DD"),
    hasta: lunes.clone().add(4, "days").format("YYYY-MM-DD"),
    dias,
    esSemanaActual: offsetSemanas === 0,
  };
};

export const formatRangoSemana = (desde, hasta) =>
  `${moment(desde, "YYYY-MM-DD").format("DD/MM")} - ${moment(hasta, "YYYY-MM-DD").format(
    "DD/MM/YYYY",
  )}`;

export const getOffsetSemanaDesdeLunes = (fechaLunes) => {
  const lunesActual = moment().startOf("isoWeek");
  const lunesFecha = moment(fechaLunes, "YYYY-MM-DD").startOf("isoWeek");
  return lunesFecha.diff(lunesActual, "weeks");
};
